import { createContext, useEffect, useState } from "react";
import { HttpService } from "../services/http";
import { Utils } from "core/utils";
import AuthZeroProvider from "features/feature_user/providers/AuthZeroProvider";

export const UserContext = createContext();

export const UserContextProvider = (props) => {

  const [authenticate, setAuthenticate] = useState();
  const [profile, setProfile] = useState();

  const urlParams = new URLSearchParams(window.location.search); 
  const signout = urlParams.get('signout')

  

  if(signout){
    // HttpService.signOut();
    // setAuthenticate(null) // why this is not working ?


    //removing the ?signout=1 from the url
    Utils.clearUrl()
  }

  const _getMe = () => {
    // BaseHttpService.loadMe().then(data => {
    //     if(data && data.length > 0) {
    //       setProfile(data[0])
    //     }
    // })

}
  

  // let localStoageToken = window.localStorage.getItem("user");
  // useEffect(() => {
  //   if (localStoageToken) {
  //     setAuthenticate(JSON.parse(localStoageToken));
  //     _getMe()
  //   }

  // }, []);

  return (
    <AuthZeroProvider>
    <UserContext.Provider value={{ setAuthenticate, authenticate , profile }}>
      {props.children}
    </UserContext.Provider>
    </AuthZeroProvider>
  );
};
